<div class="grid" style="background-color: white;">
    <div class="col-12 lg:col-6">
        <div class="custom-card-left">
            <h2>¡Felicidades! Subiste tu<br> propiedad.</h2>
            <h3 style="font-weight: 100;">
                Revisaremos y publicaremos tu anuncio.<br>
                Haz clic en la imagen para previsualizar tu propiedad o ve al dashboard
                para administrar todas tus propiedades.
            </h3>
            <div class="button-container">
                <button pButton pRipple type="button" [routerLink]="'/list'">
                    <span class="px-4">Ver todas mis propiedades</span>
                </button>
                <button pButton pRipple class="p-button-secondary" [routerLink]="'/welcome'">
                    <span class="px-4">Subir una nueva propiedad</span>
                </button>
            </div>
        </div>
    </div>

    <div class="col-12 lg:col-5 lg:col-offset-1">
        <div class="custom-card-right">
            <div class="card-container">
                <div class="confetti-background"></div>

                <app-property-card
                    *ngIf="cardVm"
                    [vm]="cardVm"
                    (select)="previewProperty($event)"
                    class="success-card clickable">
                </app-property-card>

                <p-skeleton *ngIf="loading" width="320px" height="420px" borderRadius="16px"></p-skeleton>
                <p *ngIf="!loading && !cardVm" class="no-card">No pudimos cargar la vista previa de tu propiedad.</p>
            </div>
        </div>
    </div>
</div>
